/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */


import React, {useState} from "react";

import { Row, Col, Table } from "react-bootstrap";

import { Icon } from "../../../components/Icon";



function ModelSummary(props) {
  const r = props.results.simResults;
  const t = r.timeSpan;
  const e = props.results.currentModel.simEnvironment;


  function findParamControl(id) {
    let p = e.paramControls.find( c => c.id === id);
    if ( p === undefined ) {
      return null;
    }

    return p;
  }


  let retire_param = r.simModel.findParameterByName("PrimaryRetireAge");
  let passing_param = r.simModel.findParameterByName("PrimaryLifeExpectancy");
  let retire_ctrl = props.enabled ? findParamControl(retire_param.baseID) : null;
  let passing_ctrl = props.enabled ? findParamControl(passing_param.baseID) : null;


  return (
    <>
      <Row>
        <Col>
          <Row><Col>{YearsDuration("Born", t.todaysDate, t.birthDate)}</Col></Row>

          <Row><Col><DynamicParameter desc="Retiring" date={t.retireDate} value={retire_param.adjustedValue} ctrl={retire_ctrl} onChange={props.onParamValueChange} /></Col></Row>
          <Row><Col><DynamicParameter desc="Passing" date={t.endDate} value={passing_param.adjustedValue} ctrl={passing_ctrl} onChange={props.onParamValueChange} /></Col></Row>
        </Col>
      </Row>
    </>
  );
}


// 17-Mar-2024 JC
// These are not true dynamic parameter controls yet, they are a little hard coded
// towards dates, and even then to Ritre and Passing
function DynamicParameter(props) {
  const [duration, setDuration] = useState(props.value);


  function handleDecrease(event) {
    event.preventDefault();

    if (props.value > props.ctrl.min) {
      let val = duration-1;
      setDuration(val);
      props.onChange(props.ctrl.id, val);
    } 
  }

  function handleIncrease(event) {
    event.preventDefault();

    if (props.value < props.ctrl.max) {
      let val = duration+1;
      setDuration(val);
      props.onChange(props.ctrl.id, val);
    } 
  }



  const desc_style = {
    display: "inline-block",
    width: "70px"
  }

  const left_ctrl_style = {
    paddingLeft: "5px"
  }

  const duration_style = {
    fontSize: "0.7em",
    //paddingLeft: "5px"
  }

  let enabled = props.ctrl !== null;
  // if is here because duration was not resetting after disabling controls, will revist
  if ( !enabled && props.value !== duration) {
    setDuration(props.value);
  }


  return (
    <>
      <span style={desc_style}>{props.desc}</span>
      <span>{props.date.getFullYear()}</span>

      {enabled && <span style={left_ctrl_style}><Icon.CaretLeft title="Decrease" onClick={handleDecrease} /></span>}

      <span style={duration_style}>({duration})</span>

      {enabled && <span><Icon.CaretRight title="Increase" onClick={handleIncrease} /></span>}
    </>
  );

}



//todaysDate
function YearsDuration(desc, from, to) {
  let fy = from.getFullYear();
  let ty = to.getFullYear();


  const desc_style = {
    display: "inline-block",
    width: "70px"
  }

  const duration_style = {
    fontSize: "0.7em",
  }


  return (
    <>
      <span style={desc_style}>{desc}</span><span>{ty}</span><span style={duration_style}>({fy-ty})</span>
    </>
  );

}


export default ModelSummary;
/* eslint-enable react/prop-types */

